module.exports = __webpack_public_path__ + "img/Abilitare.f54dc022.png";